import { render, staticRenderFns } from "./EncounterDiagnosis.vue?vue&type=template&id=c0a88f52&"
import script from "./EncounterDiagnosis.vue?vue&type=script&lang=js&"
export * from "./EncounterDiagnosis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports